import { NgStyle } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { OnboardingDialogResult } from '@app/+authenticated/shared/onboarding/onboarding-dialog/onboarding-dialog.model';
import { OnboardingService } from '@app/+onboarding/onboarding.service';
import { KnowledgeBaseArticleLinkModule } from '@app/pipes/knowledge-base-article-link.module';
import { TrackingService } from '@app/services/tracking.service';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonThemePalette, DIALOG_DATA, DialogActivationComponent, DialogRef } from '@sb/ui';

import { OnboardingChapterModule } from '../components/chapter.module';

@Component({
  selector: 'time-tracking-summary-dialog',
  standalone: true,
  imports: [
    DialogActivationComponent,
    TranslateModule,
    NgStyle,
    OnboardingChapterModule,
    KnowledgeBaseArticleLinkModule,
  ],
  templateUrl: './time-tracking-summary-dialog.component.html',
})
export class TimeTrackingSummaryDialogComponent implements OnInit {
  public ButtonThemePalette = ButtonThemePalette;
  public constructor(
    @Inject(DIALOG_DATA) private eventData,
    private dialogRef: DialogRef,
    private trackingService: TrackingService,
    private readonly onboardingService: OnboardingService,
  ) {}

  public get chapterCTAs() {
    return this.onboardingService.chapterCTAs;
  }

  public ngOnInit() {
    this.trackingService.event('Onboarding Time Tracking Completed', this.eventData);
  }

  public close(result: OnboardingDialogResult) {
    this.dialogRef.close(result);
  }
}
